import { render, staticRenderFns } from "./MatterSupremeCourtForm.vue?vue&type=template&id=13fc7bfe&"
import script from "./MatterSupremeCourtForm.vue?vue&type=script&lang=js&"
export * from "./MatterSupremeCourtForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterSupremeCourtForm.vue?vue&type=style&index=0&id=13fc7bfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports